import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { SonicTermData } from "../../common/classes/SonicTerm";
import { getDefaultImage } from "../../utils/GeneralUtils";
import styles from "./maingame.module.scss";

type Props = {
  games: Array<SonicTermData>;
  isMini?: boolean;
};

export const MainGame: React.FC<Props> = (props) => {
  const { games, isMini } = props;

  return (
    <div className={styles["maingame"]}>
      <Swiper
        className={styles["maingame_swiper"]}
        slidesPerView={"auto"}
        spaceBetween={16}
      >
        {games.map((value, index) => {
          return (
            <SwiperSlide
              className={
                isMini
                  ? `${styles["swiper-slide"]} ${styles["mini"]}`
                  : styles["swiper-slide"]
              }
              key={index}
            >
              <div className={styles["swiper-slide__imgBox-wrapper"]}>
                <div
                  className={
                    isMini
                      ? `${styles["swiper-slide__imgBox"]} ${styles["mini"]}`
                      : styles["swiper-slide__imgBox"]
                  }
                >
                  <img
                    src={
                      value.img?.large?.url
                        ? value.img.large.url
                        : getDefaultImage()
                    }
                  />
                </div>
              </div>
              <span
                className={
                  isMini
                    ? `${styles["swiper-slide__name"]} ${styles["mini"]}`
                    : styles["swiper-slide__name"]
                }
              >
                {value.name}
              </span>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default MainGame;
